export default function DataGrid({children}) {
  return <div class="datagrid">{children}</div>
}

DataGrid.Item = ({title, children}) => {
  return <div class="datagrid-item"><div class="datagrid-title">{title}</div><div class="datagrid-content">{children}</div></div>
}
DataGrid.Item.displayName = "Item"
